module.exports = __webpack_public_path__ + "img/13.8a9e7a18.jpg";